import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Link as RouterLink } from "react-router-dom";
import Typography from '@mui/material/Typography';

import { PATHS } from '../type/EnumPaths';

const linkSx = { flexShrink: 0, pt: 0, fontWeight: 700, textTransform: "uppercase" };
const aStyle = { color: "white", paddingRight: "3px", fontWeight: 700 };

const Navigation = () => {
  return (
    <Box 
      sx={{ 
        display: { xs: "none", lg: "flex" }, 
        position: "absolute", 
        width: "400px", 
        bottom: 0, 
        flexDirection: "column",
        color: "white",
        textAlign: "left",
        pl: "50px",
        pb: "30px",
      }}
    >
      <Link
        color="inherit"
        key={"home"}
        variant="body2"
        to={PATHS.INDEX}
        sx={linkSx}
        component={RouterLink}
      >
        Home
      </Link>
      <Link
        color="inherit"
        key={"resource"}
        variant="body2"
        to={`/${PATHS.RESOURCES}`}
        component={RouterLink}
        sx={linkSx}
      >
        Resources
      </Link>
      <Link
        color="inherit"
        key={"products"}
        variant="body2"
        to={`/${PATHS.PRODUCTS}`}
        component={RouterLink}
        sx={linkSx}
      >
        Products
      </Link>
      <Link
        color="inherit"
        key={"brands"}
        variant="body2"
        to={`/${PATHS.BRANDS}`}
        component={RouterLink}
        sx={linkSx}
      >
        Brands
      </Link>
      <Link
        color="inherit"
        key={"checkout_summary"}
        variant="body2"
        to={`/${PATHS.CHECKOUT}`}
        component={RouterLink}
        sx={linkSx}
      >
        Checkout
      </Link>
      <Link
        color="inherit"
        key={"faq"}
        variant="body2"
        to={`/${PATHS.FAQ}`}
        component={RouterLink}
        sx={linkSx}
      >
        FAQ
      </Link>
      <Link
        color="inherit"
        key={"about"}
        variant="body2"
        to={`/${PATHS.ABOUT}`}
        component={RouterLink}
        sx={linkSx}
      >
        About
      </Link>
      <Typography variant='body2'>
        <a style={aStyle} target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/audio500_/">INSTAGRAM</a> 
        <a style={aStyle} target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/audio500/">FACEBOOK</a>  
        <a style={aStyle} target="_blank" rel="noopener noreferrer" href="https://www.carousell.sg/u/audio500/">CAROUSELL</a>  
      </Typography>
      <Typography variant="body2" color="white">
        Copyright © 2022 Audio500 
      </Typography>
    </Box>
  )
}

export default Navigation;